var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramBanStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 80,
    viewBox: "0 0 382 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2325_7883)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.252 68.9151H151.633C151.633 65.228 150.677 64.2697 147 64.2697V62.6454C150.677 62.6454 151.633 61.6871 151.633 58H153.252C153.252 61.6871 154.208 62.6454 157.885 62.6454V64.2697C154.208 64.2697 153.252 65.228 153.252 68.9151ZM151.033 63.4413C151.633 63.7824 152.086 64.2535 152.443 64.8544C152.783 64.2535 153.252 63.7987 153.852 63.4413C153.252 63.1002 152.799 62.6292 152.443 62.0282C152.102 62.6292 151.633 63.084 151.033 63.4413Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.282 39.6807C193.282 36.627 191.5 34.8403 188.455 34.8403C191.5 34.8403 193.282 33.0536 193.282 30C193.282 33.0536 195.064 34.8403 198.109 34.8403C195.064 34.8403 193.282 36.627 193.282 39.6807Z",
    fill: "url(#paint0_linear_2325_7883)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330.166 42.5996C330.166 39.546 328.384 37.7593 325.339 37.7593C328.384 37.7593 330.166 35.9726 330.166 32.9189C330.166 35.9726 331.948 37.7593 334.993 37.7593C331.948 37.7593 330.166 39.546 330.166 42.5996Z",
    fill: "url(#paint1_linear_2325_7883)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M376.801 86.3901C376.801 83.3365 375.019 81.5498 371.974 81.5498C375.019 81.5498 376.801 79.7631 376.801 76.7095C376.801 79.7631 378.582 81.5498 381.628 81.5498C378.582 81.5498 376.801 83.3365 376.801 86.3901Z",
    fill: "url(#paint2_linear_2325_7883)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M253.581 19.6807C253.581 16.627 251.799 14.8403 248.754 14.8403C251.799 14.8403 253.581 13.0536 253.581 10C253.581 13.0536 255.363 14.8403 258.408 14.8403C255.363 14.8403 253.581 16.627 253.581 19.6807Z",
    fill: "url(#paint3_linear_2325_7883)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M351.88 64.168H350.26C350.26 60.7732 349.385 59.8961 346 59.8961V58.2718C349.385 58.2718 350.26 57.3947 350.26 54H351.88C351.88 57.3947 352.755 58.2718 356.14 58.2718V59.8961C352.755 59.8961 351.88 60.7732 351.88 64.168ZM349.888 59.084C350.373 59.3926 350.778 59.7824 351.07 60.2697C351.378 59.7824 351.767 59.3763 352.252 59.084C351.767 58.7754 351.362 58.3855 351.07 57.8983C350.762 58.3855 350.373 58.7916 349.888 59.084Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5603 46.6794H62.9405C62.9405 44.3242 62.4059 43.772 60.041 43.772V42.1477C62.3897 42.1477 62.9405 41.6117 62.9405 39.2402H64.5603C64.5603 41.5954 65.0948 42.1477 67.4597 42.1477V43.772C65.111 43.772 64.5603 44.308 64.5603 46.6794ZM63.2644 42.9598C63.4426 43.106 63.6046 43.2684 63.7504 43.4471C63.8962 43.2684 64.0581 43.106 64.2363 42.9598C64.0581 42.8136 63.8962 42.6512 63.7504 42.4726C63.6046 42.6512 63.4426 42.8136 63.2644 42.9598Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0915 28.4392H50.4717C50.4717 26.084 49.9372 25.5317 47.5723 25.5317V23.9075C49.921 23.9075 50.4717 23.3714 50.4717 21H52.0915C52.0915 23.3552 52.6261 23.9075 54.991 23.9075V25.5317C52.6423 25.5317 52.0915 26.0677 52.0915 28.4392ZM50.7957 24.7196C50.9739 24.8658 51.1359 25.0282 51.2816 25.2069C51.4274 25.0282 51.5894 24.8658 51.7676 24.7196C51.5894 24.5734 51.4274 24.411 51.2816 24.2323C51.1359 24.411 50.9739 24.5734 50.7957 24.7196Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2201 64.0106C45.2201 60.0798 42.9199 57.7734 39 57.7734C42.9199 57.7734 45.2201 55.4669 45.2201 51.5361C45.2201 55.4669 47.5202 57.7734 51.4401 57.7734C47.5202 57.7734 45.2201 60.0798 45.2201 64.0106Z",
    fill: "url(#paint4_linear_2325_7883)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2325_7883",
    x1: 188.471,
    y1: 34.8403,
    x2: 198.109,
    y2: 34.8403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDB592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2325_7883",
    x1: 325.339,
    y1: 37.7593,
    x2: 334.977,
    y2: 37.7593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDB592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2325_7883",
    x1: 371.974,
    y1: 81.5498,
    x2: 381.612,
    y2: 81.5498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDB592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2325_7883",
    x1: 248.754,
    y1: 14.8403,
    x2: 258.392,
    y2: 14.8403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDB592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2325_7883",
    x1: 39.0162,
    y1: 57.7734,
    x2: 51.4401,
    y2: 57.7734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDB592"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2325_7883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 382,
    height: 258,
    fill: "white",
    transform: "translate(0 -126)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramBanStar);
export default __webpack_public_path__ + "static/media/programBanStar.aa1ecabed7062eb93fa4cc12faa8daa0.svg";
export { ForwardRef as ReactComponent };